import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { IAppState } from "../store/states/app";
import { combineLatest, Observable } from "rxjs";
import {
  selectAuthenticatedUser,
  selectIsAuthenticated,
  selectAuthenticatedAdmin,
  selectIsAuthenticating,
} from "../../app/store/selectors";
import { ROUTES_CONFIG } from "../config";
import { ADMIN_ROUTES } from "../modules/admin/admin-routes";

@Injectable({ providedIn: "root" })
export default class AdminGuard implements CanActivate {
  /**
   * @param router
   * @param _store
   */
  constructor(
    private router: Router,
    private _store: Store<IAppState>,
  ) {
    //
  }

  /**
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    return new Observable<boolean>((observer) => {
      combineLatest(
        this._store.select(selectAuthenticatedAdmin),
        this._store.select(selectIsAuthenticating),
        this._store.select(selectIsAuthenticated),
        this._store.select(selectAuthenticatedUser),
      ).subscribe(([admin, authenticating, authenticated, user]) => {
        if (authenticated) {
          if (!authenticating) {
            if (!admin) {
              this.router.navigate([
                ROUTES_CONFIG.HOME_ROUTE.PARENT +
                  ROUTES_CONFIG.HOME_ROUTE.ROUTE,
              ]);
              observer.next(false);
            } else {
              if (user.me !== null && user.me.permissions.length) {
                // permission purposes in admin
                if (
                  route.data.permissions &&
                  user.me.permissions &&
                  user.me.permissions.indexOf(route.data.permissions) === -1
                ) {
                  this.router.navigate([
                    "/" +
                      ADMIN_ROUTES.DASHBOARD_ROUTE.PARENT +
                      ADMIN_ROUTES.DASHBOARD_ROUTE.ROUTE,
                  ]);
                  observer.next(false);
                }
              }
              observer.next(true);
            }
          }
        } else {
          this.router.navigate([
            ROUTES_CONFIG.HOME_ROUTE.PARENT + ROUTES_CONFIG.HOME_ROUTE.ROUTE,
          ]);
          observer.next(false);
        }
      }); //Unsubscribtion??
    });
  }
}
